import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import { Button, Dialog, TextField } from "@material-ui/core";
import { useTranslation } from "localization/translation";
import * as Api from "service";
import { getQueryParam } from "helpers/getQueryParam";
import { USER_ID, BILLING_EXPIRATION_ERROR_MSG } from "Constants";
import useStore from "context";

import { DatePicker } from "antd";
import dayjs from "dayjs";


const dateFormat = "YYYY-MM-DD";


export const BillingExpirationDate = ({
  isChangeBillingExpirationDateMode,
  setIsChangeBillingExpirationDateMode,
  setUserDetails,
  billing_expiration_date,
}) => {  
  const translation = useTranslation();
  const location = useLocation();
  const { setErrorMsg } = useStore();

  const [billingExpirationDate, setBillingExpirationDate] = useState(billing_expiration_date || null);
  const userId = getQueryParam(location, USER_ID);

  const cancelHandler = () => {
    setIsChangeBillingExpirationDateMode(false);
  };

  const saveHandler = async () => {
    if (billingExpirationDate) {
      try {
        await Api.main.updateBillingExpirationDate({
          clientId: userId,
          billingExpirationDate: billingExpirationDate,
        });
        const { data } = await Api.main.getUserDetails(userId);
        setUserDetails(data);
        setIsChangeBillingExpirationDateMode(false);
      } catch (error) {
        setErrorMsg(BILLING_EXPIRATION_ERROR_MSG);
        setIsChangeBillingExpirationDateMode(false);
      }
    }
  };
  

  return (
    <Dialog
      open={isChangeBillingExpirationDateMode}
      onClose={cancelHandler}
      classes={{ paper: "shadow-lg rounded" }}
    >
      <div className="text-center pt-2 pb-5 pl-5 pr-5">
        <h4 className="font-weight-bold mt-4">
          {translation.billing_expiration_date}
        </h4>
        <DatePicker
          defaultValue={billingExpirationDate ? dayjs(billingExpirationDate, dateFormat) : null}
          format={dateFormat}
          onChange={(date, dateString) => setBillingExpirationDate(dateString)}
          popupStyle={{ zIndex: 2000 }}
        />
        <div className="pt-4">
          <Button
            onClick={() => setIsChangeBillingExpirationDateMode(false)}
            className="btn-neutral-secondary btn-pill mx-1"
          >
            <span className="btn-wrapper--label">{translation.cancel}</span>
          </Button>
          <Button
            onClick={saveHandler}
            className={`btn-danger btn-pill mx-1 activate`}
          >
            <span className="btn-wrapper--label btn-action">
              {translation.save}
            </span>
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

